import {_get, _post} from "./Axios";

export default class TindakanApi {
    static get(koas_code) {
        return _get('/booking/Tindakan/get_by_koas/' + koas_code)
    }

    static givePartner(booking_code, tindakan_id) {
        return _post('/booking/Tindakan/give_partner', {
            booking_code,
            tindakan_id
        })
    }

    static giveBackPartner(booking_code, tindakan_id) {
        return _post('/booking/Tindakan/give_back_partner', {
            booking_code,
            tindakan_id
        })
    }
}